import store from '../store'
import {isNotEmpty} from "./utils";
import {getHostData} from "../apis/getHostData";

let socket = null
let heartbeatInterval = null //心跳包定时器

let isInitIng = false;
// WebSocket.CONNECTING	= 0
// WebSocket.OPEN	    = 1
// WebSocket.CLOSING    = 2
// WebSocket.CLOSED     = 3
function fetchUserBase() {
    return localStorage.getItem('userBase') ? JSON.parse(localStorage.getItem('userBase')) : {}
}
//创建并初始化 - 仅在登录后调用一次即可
async function ws_init(msg = '') {
    return new Promise((resolve, reject) => {
        const isLoginDisabled = store.getters["user/isLoginDisabled"];
        if (isLoginDisabled) {
            console.log('登录信息已失效，禁止连接ws');
            return reject()
        }

        const token = store.getters["user/userBase"].token
        if (!token) {
            return reject(new Error('token is underfined'))
        }
        if (socket) {
            ws_close()
        }

        // let socketUrl = store.getters['channel/getWSurl']
        if(isInitIng){
            return
        }
        isInitIng = true;
        let hostData = getHostData();
        let socketUrl = hostData.VUE_APP_SOCKETSERVERHOST+'/websocket/'+fetchUserBase().mark;
        socket = new WebSocket(socketUrl + '?token=' + token);
        let innerSocket = socket;
        socket.onopen = function (res) {
            isInitIng = false;
            if(isNotEmpty(msg)){
                innerSocket.send(msg);
            }
            start_heartbeat()
            resolve()
        };

        socket.onmessage = function (res) {
            isInitIng = false;
            if (JSON.parse(res.data).command !== 'front_check') {
                store.dispatch('channel/socket_message', JSON.parse(res.data), { root: true })
            }
        };

        socket.onerror = function (res) {
            isInitIng = false;
            console.log("onerror://", res)
        };

        socket.onclose =async function (res) {
            isInitIng = false;
            socket = null
            stop_heartbeat()
            //重新连接
            try{
                await ws_init(msg)
            }catch (e){
                console.error(e);
            }
        };
    })
}

//发送心跳包
function start_heartbeat() {
    if (localStorage.getItem('s_heart') === 'close') return

    const isLoginDisabled = store.getters["user/isLoginDisabled"];
    if (isLoginDisabled) {
        console.log('登录信息已失效，禁止发送心跳包');
        return
    }

    if (!heartbeatInterval) {
        heartbeatInterval = setInterval(() => {
            // slog('当前时间为：',Date.now());
            ws_check().then(res => {
                slog('发送心跳包：//', store.getters['channel/getHartbeat']);
                socket.send(JSON.stringify(store.getters['channel/getHartbeat']))
            })
        }, 10000);
    }
}
//停止发送心跳包
function stop_heartbeat() {
    clearInterval(heartbeatInterval);
    heartbeatInterval = null;
}

//检查连接状态，网络发起前都需要调用这个方法
function ws_check() {
    const isLoginDisabled = store.getters["user/isLoginDisabled"];
    if (isLoginDisabled) {
        console.log('登录信息已失效，禁止发送消息');
        return new Promise((resolve, reject) => {
            return reject()
        })
    }


    slog('ws_check')
    return new Promise((resolve, reject) => {
        //检查ws是否链接
        //0-未连接，1-已连接，2-连接中，3-连接断开
        if (socket.readyState === WebSocket.OPEN) {
            slog('WebSocket.OPEN 可以发送消息')
            return resolve()
        } else if (socket.readyState === WebSocket.CLOSED) {
            slog('WebSocket.CLOSED 即将重新连接')
            ws_init().then(res => {
                slog('连接成功', res)
                return resolve()
            }).catch(err => {
                slog('ws连接失败', err)
                return reject()
            })
        } else if (socket.readyState === WebSocket.CONNECTING) {
            slog('WebSocket.CONNECTING 正在连接...')
            setTimeout(() => {
                ws_check().then(res => {
                    slog('连接成功', res)
                    resolve()
                }).catch(err => {
                    console.log('ws连接失败', err)
                    reject()
                })
            }, 200);
        } else if (socket.readyState === WebSocket.CLOSING) {
            slog('WebSocket.CLOSING 正在关闭...')
            setTimeout(() => {
                ws_check().then(res => {
                    slog('连接成功', res)
                    resolve()
                }).catch(err => {
                    console.log('ws连接失败', err)
                    reject()
                })
            }, 200);
        } else {
            throw new Error('socket.readyState异常')
        }
    })
}

//断开连接 - 退出登录时需要调用
function ws_close() {
    stop_heartbeat()
    socket.close()
    socket = null
}

//发送消息
function ws_send(msg) {
    if (socket === null) {
        ws_init(msg).then(res => {
            socket.send(msg)
        })
        return
    }

    ws_check().then(res => {
        socket.send(msg)
    })
}

function slog(...args) {
    if (localStorage.getItem('slog') === 'open') {
        console.log(...args);
    }
}

export {
    ws_init,
    ws_send,
    ws_close,
}
